export function subAccountsSwitch (userData, ability) {
  if (userData?.subAccountOrgs?.length > 1 && userData.loggedInOrganization && userData.parentOrganization) {
    const subAccountsMenuItems = []

    userData.subAccountOrgs.forEach((org) => {
      if (org.parent_organization_id === userData.parentOrganization.organization_id) {
        subAccountsMenuItems.push({
          name: org.name,
          icon: 'sub-account-child',
          type: 'link',
          link: `/app/Merchant/#/user-management/account-switch/${org.organization_id}`,
          selected: userData.loggedInOrganization.organization_id === org.organization_id,
          tags: ['account-switch']
        })
      }
    })

    const children = [
      {
        name: userData.parentOrganization.name,
        icon: 'sub-account-parent',
        type: 'link',
        link: `/app/Merchant/#/user-management/account-switch/${userData.parentOrganization.organization_id}`,
        selected: userData.loggedInOrganization.organization_id === userData.parentOrganization.organization_id,
        tags: ['account-switch', 'header']
      },
      {
        name: null,
        icon: null,
        link: null,
        type: 'separator',
        selected: false,
        tags: ['account-switch'],
        children: []
      },
      {
        type: 'account-switch-sub-menu',
        tags: ['account-switch'],
        children: subAccountsMenuItems
      }
    ]

    if (ability.can('view', 'Manage Subaccounts')) {
      children.push({
        name: null,
        icon: null,
        link: null,
        type: 'separator',
        selected: false,
        tags: ['account-switch'],
        children: []
      })
      children.push({
        name: 'Manage Subaccounts',
        icon: 'account-management',
        link: '/app/Merchant/#/user-management/account-management',
        type: 'link',
        selected: false,
        tags: ['account-switch', 'footer'],
        children: []
      })
    }

    return [
      {
        name: null,
        icon: null,
        link: null,
        type: 'separator',
        selected: false,
        tags: ['account-switch'],
        children: []
      },
      {
        name: userData.loggedInOrganization.name,
        icon: userData.loggedInOrganization.parent_organization_id == null ? 'sub-account-parent' : 'sub-account-child',
        type: 'account-switch',
        children
      },
      {
        name: null,
        icon: null,
        link: null,
        type: 'separator',
        selected: false,
        tags: ['account-switch'],
        children: []
      }
    ]
  }

  return []
}
